import ChangeSubscriptionModal from "./ChangeSubscriptionModal";

export default ChangeSubscriptionModal;
